// extracted by mini-css-extract-plugin
export default {"rosterConfigHeight":"RosterConfig_rosterConfigHeight__JFdVO","buttonContainer":"RosterConfig_buttonContainer__rnHza"};